import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';
import type { Rarity, Sport } from '@sorare/core/src/__generated__/globalTypes';
import { HeadlineL } from '@sorare/core/src/atoms/typography';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_PLAYERS_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { scarcityMessages } from '@sorare/core/src/lib/scarcity';

type Props = {
  player: {
    slug: string;
    displayName: string;
  };
  rarity: Rarity;
  sport: Sport;
};

const SecondaryMarketStackedTitle = styled(HeadlineL)`
  display: inline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &,
  & a {
    color: var(--c-white);
  }

  & span {
    margin-left: var(--unit);
    color: var(--c-nd-600);
  }
`;

export const MarketStackTitle = ({ player, rarity, sport }: Props) => {
  const { generateSportContextPath } = useSportContext();
  const playerUrl = generateSportContextPath(ANY_SPORT_PLAYERS_SLUG, {
    params: { slug: player.slug },
    sport,
  });

  return (
    <PageHeader
      customTitle={
        <SecondaryMarketStackedTitle as="h3">
          <Link to={playerUrl}>{player.displayName}</Link>
          <span>
            <FormattedMessage {...scarcityMessages[rarity]} />
          </span>
        </SecondaryMarketStackedTitle>
      }
    />
  );
};
